import React, {useState} from 'react'
import WalletIcon from '../../icons/dashboardBarIcons/Wallet';
import Account from '../../icons/dashboardBarIcons/Account';
import Rentals from '../../icons/dashboardBarIcons/Rentals';
import Message from '../../icons/dashboardBarIcons/Message';
import { useSelector } from 'react-redux';
import { 
Responsive, 
ResponsiveBar, 
ResponsiveIconContainer, 
} from './responsiveBarStyle';
import NotificationIcon from '../../icons/dashboardBarIcons/NotificationIcon';




const ResponsiveDashBar = ({account, wallet, icon, message}) => {

  const demo = useSelector((state) => state)

  console.log(demo);

  const [clickState, setClickState] = useState('none');
  
  const Click = () =>{
    if(clickState === "flex"){
      setClickState("none")
    } else{
    setClickState('flex')
    }
  }



  return (
    <>
        <ResponsiveBar onClick={Click}  viewBox="0 0 24 24">
          <path fill="white" d="M3,15H21V13H3V15M3,19H21V17H3V19M3,11H21V9H3V11M3,5V7H21V5H3Z" />
        </ResponsiveBar>
        <Responsive view={clickState}>
                <ResponsiveIconContainer>
                        <WalletIcon />
                </ResponsiveIconContainer>
                <ResponsiveIconContainer onClick={account}>
                        <Account />
                </ResponsiveIconContainer>
                <ResponsiveIconContainer>
                    <Rentals />
                </ResponsiveIconContainer>
                <ResponsiveIconContainer>
                    <Message />
                </ResponsiveIconContainer>
                <NotificationIcon/>
          </Responsive>
    
    </>
  )
}

export default ResponsiveDashBar